import { Popover } from "@mui/material";
import styled from "@emotion/styled";

const StyledPopover = styled(Popover)(({ theme, colors }) => ({
  " .MuiPaper-root": {
    borderRadius: "1.5rem",
    padding: "2rem",
    backgroundColor: colors.background?.popover
  },
}));

export default StyledPopover;
